import authController from './auth'
import userController from './user'
import filesController from './files'
import mandatoryDisplaysController from './mandatory-displays'

export const API = {
  auth: authController,
  user: userController,
  file: filesController,
  mandatoryDisplay: mandatoryDisplaysController,
}
